/**
 * @desc 明细
 */
const URL = "/rantion-app-center";
import http, { updateResponse } from "@/http";
export type Response = defs.appCenter.ResponseDto<defs.appCenter.AppDomainRoleResponseDto>;
export function request(code: string, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/role/${code}`, {
      method: "GET",

      ...options,
    }),
  );
}
